import React, { cloneElement } from 'react';
import { StyledTagGroup } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const TagGroup = ({ children, size, className, margin, ...rest }) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const modifiedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                size: child.props.size ?? size
            });
        }
        return null;
    });
    return (React.createElement(StyledTagGroup, { size: size, className: className, margin: margin, ...a11yProps, ...dataProps }, modifiedChildren));
};
//# sourceMappingURL=index.js.map